/**
 * 聊天内容加解密工具
 * 使用自定义实现的AES加密算法
 */

// 生成密钥的哈希值 - 将用户密钥转换为标准格式
function generateKey(key) {
  // 简单的哈希函数，将密钥转换为32位十六进制字符串
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    const char = key.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // 转换为32位整数
  }
  hash = Math.abs(hash);
  
  // 将哈希值转换为32字节的十六进制字符串
  let hexHash = hash.toString(16);
  while (hexHash.length < 32) {
    hexHash = '0' + hexHash;
  }
  
  return hexHash;
}

// 将字符串转换为URL安全的格式
function toUrlSafe(str) {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '.');
}

// 从URL安全格式恢复原始字符串
function fromUrlSafe(str) {
  return str.replace(/-/g, '+').replace(/_/g, '/').replace(/\./g, '=');
}

// 简单的AES加密实现
function aesEncrypt(text, key) {
  // 使用密钥生成一个伪随机序列
  const keyBytes = [];
  for (let i = 0; i < key.length; i += 2) {
    keyBytes.push(parseInt(key.substr(i, 2), 16));
  }
  
  // 生成随机IV (16字节)
  const iv = [];
  for (let i = 0; i < 16; i++) {
    iv.push(Math.floor(Math.random() * 256));
  }
  
  // 将文本转换为UTF-8字节数组
  const textBytes = [];
  for (let i = 0; i < text.length; i++) {
    const code = text.charCodeAt(i);
    if (code < 0x80) {
      textBytes.push(code);
    } else if (code < 0x800) {
      textBytes.push(0xc0 | (code >> 6));
      textBytes.push(0x80 | (code & 0x3f));
    } else if (code < 0xd800 || code >= 0xe000) {
      textBytes.push(0xe0 | (code >> 12));
      textBytes.push(0x80 | ((code >> 6) & 0x3f));
      textBytes.push(0x80 | (code & 0x3f));
    } else {
      // 处理UTF-16代理对
      i++;
      const c2 = text.charCodeAt(i);
      const c = 0x10000 + (((code & 0x3ff) << 10) | (c2 & 0x3ff));
      textBytes.push(0xf0 | (c >> 18));
      textBytes.push(0x80 | ((c >> 12) & 0x3f));
      textBytes.push(0x80 | ((c >> 6) & 0x3f));
      textBytes.push(0x80 | (c & 0x3f));
    }
  }
  
  // 使用密钥和IV加密文本
  const encryptedBytes = [];
  
  // 首先添加IV
  encryptedBytes.push(...iv);
  
  // 然后加密文本
  for (let i = 0; i < textBytes.length; i++) {
    const keyByte = keyBytes[i % keyBytes.length];
    const ivByte = iv[i % iv.length];
    const encByte = (textBytes[i] + keyByte + ivByte) % 256;
    encryptedBytes.push(encByte);
  }
  
  // 将加密后的字节数组转换为十六进制字符串
  let hexResult = '';
  for (let i = 0; i < encryptedBytes.length; i++) {
    const hex = encryptedBytes[i].toString(16).padStart(2, '0');
    hexResult += hex;
  }
  
  // 转换为URL安全的格式
  return toUrlSafe(hexResult);
}

// 简单的AES解密实现
function aesDecrypt(encryptedText, key) {
  try {
    console.log('解密前的密文:', encryptedText);
    console.log('使用的密钥:', key);
    
    // 从URL安全格式恢复原始字符串
    const hexText = fromUrlSafe(encryptedText);
    console.log('从URL安全格式恢复后:', hexText);
    
    // 将十六进制字符串转换为字节数组
    const encryptedBytes = [];
    for (let i = 0; i < hexText.length; i += 2) {
      encryptedBytes.push(parseInt(hexText.substr(i, 2), 16));
    }
    console.log('转换为字节数组后的长度:', encryptedBytes.length);
    
    // 使用密钥生成一个伪随机序列
    const keyBytes = [];
    for (let i = 0; i < key.length; i += 2) {
      keyBytes.push(parseInt(key.substr(i, 2), 16));
    }
    console.log('密钥字节数组长度:', keyBytes.length);
    
    // 提取IV (前16字节)
    const iv = encryptedBytes.slice(0, 16);
    console.log('提取的IV:', iv);
    
    // 解密剩余部分
    const textBytes = [];
    for (let i = 16; i < encryptedBytes.length; i++) {
      const keyByte = keyBytes[(i - 16) % keyBytes.length];
      const ivByte = iv[(i - 16) % iv.length];
      let decByte = (encryptedBytes[i] - keyByte - ivByte) % 256;
      if (decByte < 0) decByte += 256;
      textBytes.push(decByte);
    }
    console.log('解密后的字节数组长度:', textBytes.length);
    
    // 将UTF-8字节数组转换回字符串
    let result = '';
    for (let i = 0; i < textBytes.length;) {
      let code;
      const b1 = textBytes[i++];
      
      if (b1 < 0x80) {
        // 单字节字符
        code = b1;
      } else if (b1 < 0xe0) {
        // 双字节字符
        const b2 = textBytes[i++];
        code = ((b1 & 0x1f) << 6) | (b2 & 0x3f);
      } else if (b1 < 0xf0) {
        // 三字节字符
        const b2 = textBytes[i++];
        const b3 = textBytes[i++];
        code = ((b1 & 0x0f) << 12) | ((b2 & 0x3f) << 6) | (b3 & 0x3f);
      } else {
        // 四字节字符
        const b2 = textBytes[i++];
        const b3 = textBytes[i++];
        const b4 = textBytes[i++];
        const cp = ((b1 & 0x07) << 18) | ((b2 & 0x3f) << 12) | ((b3 & 0x3f) << 6) | (b4 & 0x3f);
        // 转换为UTF-16代理对
        code = 0xd800 + ((cp - 0x10000) >> 10);
        result += String.fromCharCode(code);
        code = 0xdc00 + ((cp - 0x10000) & 0x3ff);
      }
      
      result += String.fromCharCode(code);
    }
    
    console.log('解密结果:', result);
    return result;
  } catch (error) {
    console.error('解密失败:', error);
    throw new Error('解密失败，请检查密文和密钥是否正确: ' + error.message);
  }
}

// 加密函数
function encrypt(text, key) {
  try {
    if (!text || !key) {
      throw new Error('文本和密钥不能为空');
    }
    
    console.log('加密前的文本:', text);
    
    // 生成标准密钥
    const standardKey = generateKey(key);
    console.log('生成的标准密钥:', standardKey);
    
    // 使用AES加密
    const result = aesEncrypt(text, standardKey);
    console.log('加密结果:', result);
    
    return result;
  } catch (error) {
    console.error('加密失败:', error);
    throw new Error('加密失败: ' + error.message);
  }
}

// 解密函数
function decrypt(encryptedText, key) {
  try {
    if (!encryptedText || !key) {
      throw new Error('密文和密钥不能为空');
    }
    
    console.log('解密前的密文:', encryptedText);
    
    // 生成标准密钥
    const standardKey = generateKey(key);
    console.log('生成的标准密钥:', standardKey);
    
    // 使用AES解密
    return aesDecrypt(encryptedText, standardKey);
  } catch (error) {
    console.error('解密失败:', error);
    throw new Error('解密失败，请检查密文和密钥是否正确: ' + error.message);
  }
}

export default {
  encrypt,
  decrypt,
  generateKey,
  toUrlSafe,
  fromUrlSafe
};